
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.718 2.404L9.122 6.999l4.596 4.597-2.122 2.122L7 9.12l-4.596 4.597-2.122-2.122L4.88 7 .282 2.404 2.404.282 7 4.88 11.596.282l2.122 2.122z","fill-rule":"evenodd","fill":"currentColor"}})])
          )
        }
      }
    